import {objectDiff} from '@/_application/core/utils/deep-equal-object';
import {ProductListItemsQueryOptions} from '@/_application/modules/products/request/product-list.request';

export const isParamsChanged = (
    serverQueryOptions: ProductListItemsQueryOptions,
    clientQueryOptions: ProductListItemsQueryOptions,
) => {
    return !(
        Object.keys(objectDiff(serverQueryOptions.filter ?? {}, clientQueryOptions.filter ?? {})).length === 0 &&
        Object.keys(objectDiff(serverQueryOptions.sort ?? {}, clientQueryOptions.sort ?? {})).length === 0 &&
        clientQueryOptions.search === serverQueryOptions.search &&
        clientQueryOptions.currentPage === serverQueryOptions.currentPage &&
        clientQueryOptions.pageSize === serverQueryOptions.pageSize
    );
};
